import React, { useEffect, useState } from "react";
import { addComma, HOSTNAME, isExternalUrl, REGISTRY_URL } from "@src/utils";
import { useThrottle } from "@src/utils/hooks/useThrottle";
import {
  addLoungeCode,
  getLoungeCode,
  getSecretLoungeMissionInfo,
  secretLoungeApplyForDiscount,
  secretLoungeReward,
} from "./api";
import { TMissionType, TResMissionInfo } from "./type";
import { logEvent } from "@src/reactGa";

import SecretLoungeModal from "./modal/SecretLoungeModal";

import "./secretLounge.scss";

import SecretLoungeBg from "./imgs/SecretLoungeBg.webp";
import InputModal from "@src/components/common/modal/inputModal/InputModal";

import ResortBannerImg from "./imgs/resort-banner.png";

export default function SecretLounge() {
  const throttle = useThrottle();
  // 초대코드 입력 관련
  const [isShowEndNoticeModal, setIsShowEndNoticeModal] = useState(true);
  const [secretLoungeCodeModal, setSecretLoungeCodeModal] = useState(false);
  const [secretLoungeConfirmCode, setSecretLoungeConfirmCode] = useState("");
  const [secretLoungeErrorText, setSecretLoungeErrorText] = useState("");

  // 미션 정보 관련
  const [missionInfo, setMissionInfo] = useState<TResMissionInfo>(undefined);
  // 모달 관련
  const [isShowModal, setIsShowModal] = useState(false);
  const [modalPointText, setModalPointText] = useState("");
  const [modalBoldText, setModalBoldText] = useState("");
  const [modalText, setModalText] = useState("");
  const [modalBtns, setModalBtns] =
    useState<{ name: string; action: () => void; style?: React.CSSProperties }[]>(undefined);

  const handleClickMissionInfoBtn = (missionType: TMissionType) => {
    switch (missionType) {
      case "SDM_CONTRACT":
        setModalPointText("스드메 2품목 이상 계약하면 30,000원 적립");
        setModalBoldText(
          `웨딩북 앱에서 원하는 지역과 스타일에 \n맞는 스드메 업체를 찾아서 상담을 받아보세요.\n상담 후, 웨딩북을 통해 계약까지 완료하세요!`,
        );
        setModalText(
          `웨딩북을 통해 최초 예약 후 진행해야 합니다.\n캐시백 태그가 붙어있는 업체에서 계약해야\n캐시백이 지급됩니다.`,
        );
        setModalBtns([
          {
            name: "플래너 업체 찾아보기",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              setIsShowModal(false);
              window.location.href = isExternalUrl(`${HOSTNAME}/product/2?hidetop=true`);
            },
          },
        ]);
        setIsShowModal(true);
        break;
      case "WEDDING_JEWELRY_CONTRACT":
        setModalPointText("예물 업체 계약하면 3~5% 캐시백 + 40,000원 추가 적립");
        setModalBoldText(
          `웨딩북에서 예물 업체를 검색하고,\n마음에 드는 업체를 찾아 상담을 받아보세요.\n캐시백 태그가 있는 업체에서 계약하세요.`,
        );
        setModalText(
          `웨딩북을 통해 최초 예약 후 진행해야 합니다.\n캐시백 태그가 붙어있는 업체에서 계약해야\n캐시백이 지급됩니다.`,
        );
        setModalBtns([
          {
            name: "예물 업체 찾아보기",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              setIsShowModal(false);
              window.location.href = isExternalUrl(`${HOSTNAME}/partner-list/8?hidetop=true`);
            },
          },
        ]);
        setIsShowModal(true);
        break;
      case "WEDDING_SUIT_CONTRACT":
        setModalPointText("예복 업체 계약하면 3~5% 캐시백 + 30,000원 추가 적립");
        setModalBoldText(
          `웨딩북에서 예복 업체를 검색하고,\n마음에 드는 업체를 찾아 상담을 받아보세요.\n캐시백 태그가 있는 업체에서 계약하세요.`,
        );
        setModalText(
          `웨딩북을 통해 최초 예약 후 진행해야 합니다.\n캐시백 태그가 붙어있는 업체에서 계약해야\n캐시백이 지급됩니다.`,
        );
        setModalBtns([
          {
            name: "예복 업체 찾아보기",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              setIsShowModal(false);
              window.location.href = isExternalUrl(`${HOSTNAME}/partner-list/15?hidetop=true`);
            },
          },
        ]);
        setIsShowModal(true);
        break;
      case "HANBOK_CONTRACT":
        setModalPointText("한복 업체 계약하면 3~5% 캐시백 + 30,000원 추가 적립");
        setModalBoldText(
          `웨딩북에서 한복 업체를 검색하고,\n마음에 드는 업체를 찾아 상담을 받아보세요.\n캐시백 태그가 있는 업체에서 계약하세요.`,
        );
        setModalText(
          `웨딩북을 통해 최초 예약 후 진행해야 합니다.\n캐시백 태그가 붙어있는 업체에서 계약해야\n캐시백이 지급됩니다.`,
        );
        setModalBtns([
          {
            name: "한복 업체 찾아보기",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              setIsShowModal(false);
              window.location.href = isExternalUrl(`${HOSTNAME}/partner-list/6?hidetop=true`);
            },
          },
        ]);
        setIsShowModal(true);
        break;
      case "HONEYMOON_CONTRACT":
        setModalPointText("신혼여행 계약하면 20,000원 적립");
        setModalBoldText(
          `웨딩북에서 신혼여행 업체를 검색하고,\n마음에 드는 업체를 찾아 상담을 받아보세요.\n캐시백 태그가 있는 업체에서 계약하세요.`,
        );
        setModalText(
          `웨딩북을 통해 최초 예약 후 진행해야 합니다.\n캐시백 태그가 붙어있는 업체에서 계약해야\n캐시백이 지급됩니다.`,
        );
        setModalBtns([
          {
            name: "신혼여행 업체 찾아보기",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              setIsShowModal(false);
              window.location.href = isExternalUrl(`${HOSTNAME}/partner-list/19?hidetop=true`);
            },
          },
        ]);
        setIsShowModal(true);
        break;
      case "WISHLIST_ADD":
        setModalPointText("위시리스트에 상품을 담으면 10,000원 적립");
        setModalBoldText(
          `웨딩북 스토어에서 상품을 검색하고,\n마음에 드는 상품을 위시리스트에 담아보세요.`,
        );
        setModalText("");
        setModalBtns([
          {
            name: "상품 담으러 가기",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              setIsShowModal(false);
              window.location.href = isExternalUrl(`${REGISTRY_URL}?hidetop=true`);
            },
          },
        ]);
        setIsShowModal(true);
        break;
      case "WISHLIST_SHARE":
        setModalPointText("위시리스트에 상품을 공유하면 20,000원 적립");
        setModalBoldText(`청첩장, 초대장을 만들어\n친구에게 위시리스트를 공유해보세요.`);
        setModalText(`위시리스트 공유 마이웨딩 > 청첩장 공유하기, 초대장을\n친구에게 공유하세요.`);
        setModalBtns([
          {
            name: "위시리스트 공유하러가기",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              setIsShowModal(false);
              window.location.href = isExternalUrl(`${REGISTRY_URL}/my-wedding?hidetop=true`);
            },
          },
        ]);
        setIsShowModal(true);
        break;
      case "FRIEND_GIFT":
        setModalPointText("위시리스트 상품을 선물 받으면 30,000원 적립");
        setModalBoldText(
          `친구에게 청첩장, 초대장을 공유해\n위시리스트에 담긴 상품을 선물 받으세요.`,
        );
        setModalText(``);
        setModalBtns([
          {
            name: "위시리스트 공유하고 선물 받기",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              setIsShowModal(false);
              window.location.href = isExternalUrl(`${REGISTRY_URL}/my-wedding?hidetop=true`);
            },
          },
        ]);
        setIsShowModal(true);
        break;
      default:
        break;
    }
  };
  const handleClickAccrueBtn = throttle((missionType: TMissionType) => {
    if (missionInfo.discountApplyStatus === "COMPLETED")
      return alert("할인혜택 신청을 완료하여 적립이 불가능합니다.");

    switch (missionType) {
      case "SDM_CONTRACT":
        // setModalPointText("");
        // setModalBoldText(``);
        // setModalText(
        //   `시크릿 라운지 혜택은 즉시 적립되지 않으며,\n영업일 기준 7일 이내에 확인 후 적립됩니다.`,
        // );
        // setModalBtns([
        //   {
        //     name: "확인",
        //     style: { backgroundColor: "#6951F6" },
        //     action: () => {
        //       secretLoungeReward(missionType)
        //         .then(() => {
        //           // 적립하기 API 호출 후 미션정보 갱신
        //           setIsShowModal(false);
        //           getMissionInfo();
        //         })
        //         .catch((error) => console.error(error));
        //     },
        //   },
        // ]);
        // setIsShowModal(true);
        window.location.href = "h2mwbell://cashback";
        break;
      case "WEDDING_JEWELRY_CONTRACT":
        window.location.href = "h2mwbell://cashback";
        break;
      case "WEDDING_SUIT_CONTRACT":
        window.location.href = "h2mwbell://cashback";
        break;
      case "HANBOK_CONTRACT":
        window.location.href = "h2mwbell://cashback";
        break;
      case "HONEYMOON_CONTRACT":
        window.location.href = "h2mwbell://cashback";
        break;
      case "WISHLIST_ADD":
        setModalPointText("");
        setModalBoldText(``);
        setModalText(
          `시크릿 라운지 혜택은 즉시 적립되지 않으며,\n영업일 기준 7일 이내에 확인 후 적립됩니다.`,
        );
        setModalBtns([
          {
            name: "확인",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              secretLoungeReward(missionType)
                .then(() => {
                  // 적립하기 API 호출 후 미션정보 갱신
                  setIsShowModal(false);
                  getMissionInfo();
                })
                .catch((error) => console.error(error));
            },
          },
        ]);
        setIsShowModal(true);
        break;
      case "WISHLIST_SHARE":
        setModalPointText("");
        setModalBoldText(``);
        setModalText(
          `시크릿 라운지 혜택은 즉시 적립되지 않으며,\n영업일 기준 7일 이내에 확인 후 적립됩니다.`,
        );
        setModalBtns([
          {
            name: "확인",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              secretLoungeReward(missionType)
                .then(() => {
                  // 적립하기 API 호출 후 미션정보 갱신
                  setIsShowModal(false);
                  getMissionInfo();
                })
                .catch((error) => console.error(error));
            },
          },
        ]);
        setIsShowModal(true);
        break;
      case "FRIEND_GIFT":
        setModalPointText("");
        setModalBoldText(``);
        setModalText(
          `시크릿 라운지 혜택은 즉시 적립되지 않으며,\n영업일 기준 7일 이내에 확인 후 적립됩니다.`,
        );
        setModalBtns([
          {
            name: "확인",
            style: { backgroundColor: "#6951F6" },
            action: () => {
              secretLoungeReward(missionType)
                .then(() => {
                  // 적립하기 API 호출 후 미션정보 갱신
                  setIsShowModal(false);
                  getMissionInfo();
                })
                .catch((error) => console.error(error));
            },
          },
        ]);
        setIsShowModal(true);
        break;

      default:
        break;
    }
  }, 1000);

  const handleClickDiscountBtn = throttle(() => {
    const completedMissionCount = missionInfo.missionItems.filter(
      (mission) => mission.status === "COMPLETED",
    ).length;
    const totalMissionCount = missionInfo.missionItems.length;

    if (completedMissionCount === totalMissionCount) {
      // 할인신청 API 호출 후 성공시 신청완료 팝업 노출
      secretLoungeApplyForDiscount()
        .then(() => {
          setModalPointText("");
          setModalBoldText(`시크릿 라운지 혜택 신청이 완료되었습니다!`);
          setModalText(
            `결혼을 진심으로 축하드려요.\n1:1채팅창에 적립금을 지급받을\n은행 / 계좌번호 / 예금주 정보를 남겨주세요.\n적립금은 신청일 기준 다음달 15일에 지급됩니다.`,
          );
          setModalBtns([
            {
              name: "확인",
              style: { backgroundColor: "#6951F6" },
              action: () => {
                setIsShowModal(false);
                window.location.href = "h2mwbell://webview/close";
              },
            },
          ]);
          setIsShowModal(true);
          getMissionInfo();
        })
        .catch((error) => console.error(error));
    } else {
      setModalPointText("");
      setModalBoldText(`🚨 아직 미션이 남아있어요!\n지금 신청하면 추가 혜택을 더 받을 수 없어요.`);
      setModalText(
        `남은 미션을 완료하면 더 많은 혜택을 받을 수 있어요.\n정말 지금 신청하시겠어요?`,
      );
      setModalBtns([
        {
          name: "취소",
          style: { backgroundColor: "#f2f2f2", color: "#191919", fontWeight: "normal" },
          action: () => {
            setIsShowModal(false);
          },
        },
        {
          name: "확인",
          style: { backgroundColor: "#6951F6" },
          action: () => {
            //할인신청 API 호출 후 성공시 신청완료 팝업 노출
            secretLoungeApplyForDiscount()
              .then(() => {
                setModalPointText("");
                setModalBoldText(`시크릿 라운지 혜택 신청이 완료되었습니다!`);
                setModalText(
                  `결혼을 진심으로 축하드려요.\n1:1채팅창에 적립금을 지급받을\n은행 / 계좌번호 / 예금주 정보를 남겨주세요.\n적립금은 신청일 기준 다음달 15일에 지급됩니다.`,
                );
                setModalBtns([
                  {
                    name: "1:1채팅 바로가기",
                    style: { backgroundColor: "#6951F6" },
                    action: () => {
                      setIsShowModal(false);
                      // window.location.href = "h2mwbell://chat";
                      window.location.href = isExternalUrl(`${HOSTNAME}/mypage/chat`);
                    },
                  },
                ]);
                getMissionInfo();
              })
              .catch((error) => console.error(error));
          },
        },
      ]);
      setIsShowModal(true);
    }
  }, 1000);

  const getMissionInfo = () => {
    getSecretLoungeMissionInfo()
      .then((res) => {
        setMissionInfo(res.data.item);
      })
      .catch((error) => console.error(error));
  };

  const visibilitychangeHandler = () => {
    if (document.visibilityState === "hidden") return;

    getMissionInfo();
  };

  useEffect(() => {
    document.addEventListener("visibilitychange", visibilitychangeHandler);

    return () => {
      document.removeEventListener("visibilitychange", visibilitychangeHandler);
    };
  }, []);

  useEffect(() => {
    if (isShowEndNoticeModal) return;
    // 시크릿 라운지 코드를 한번이라도 입력한 적이 있다면 라운지 코드 체크 없이 페이지 이동
    getLoungeCode()
      .then((res) => {
        getMissionInfo();
      })
      .catch(() => {
        setSecretLoungeCodeModal(true);
      });
  }, [isShowEndNoticeModal]);

  const goToResortPage = () => {
    logEvent("SecretLounge_ResomBanner_Click", {});

    const link = isExternalUrl(`https://resomwedding.pscms.co.kr/main/index.php`);
    window.location.href = link;
  };

  return (
    <section className="page-secret-lounge">
      <img src={SecretLoungeBg} alt="" style={{ display: "block" }} />
      {missionInfo && (
        <div className="absolute-box">
          <div className="resort-banner-wrap" onClick={goToResortPage}>
            <img src={ResortBannerImg} alt="" className="resort-banner" />
          </div>
          <article className="total-reward-wrap">
            <p>
              총 <span>{addComma(missionInfo.totalReward)}원</span> 적립
            </p>
          </article>
          <article className="mission-wrap">
            <section className="mission-list-box">
              <article className="mission-status-box">
                <p>미션 현황</p>
                <p>
                  {
                    missionInfo.missionItems
                      .filter(
                        (mission) =>
                          !["WISHLIST_ADD", "WISHLIST_SHARE", "FRIEND_GIFT"].includes(mission.type),
                      )
                      .filter((item) => item.status === "COMPLETED").length
                  }
                  /
                  {
                    missionInfo.missionItems.filter(
                      (mission) =>
                        !["WISHLIST_ADD", "WISHLIST_SHARE", "FRIEND_GIFT"].includes(mission.type),
                    ).length
                  }
                </p>
              </article>
              {missionInfo.missionItems
                .filter(
                  (mission) =>
                    !["WISHLIST_ADD", "WISHLIST_SHARE", "FRIEND_GIFT"].includes(mission.type),
                )
                .map(({ type, title, reward, status, imageUrl }, index) => (
                  <article className="mission-list-item" key={`mission-${index}`}>
                    <div className="mission-list-item-left">
                      <img src={imageUrl} alt="" className="mission-icon" />
                      <div>
                        <strong>{title}</strong>
                        {reward && <p>{reward}</p>}
                      </div>
                    </div>
                    {status === "MISSION_INFO" && (
                      <button className="info-btn" onClick={() => handleClickMissionInfoBtn(type)}>
                        미션안내
                      </button>
                    )}
                    {status === "ACCRUE" && (
                      <button className="save-btn" onClick={() => handleClickAccrueBtn(type)}>
                        적립하기
                      </button>
                    )}
                    {status === "PENDING_APPROVAL" && (
                      <button className="wait-btn">승인대기</button>
                    )}
                    {status === "COMPLETED" && (
                      <button className="complete-btn">
                        {type === "HALL_CONTRACT" ? "완료" : "적립완료"}
                      </button>
                    )}
                  </article>
                ))}
              <article>
                {missionInfo.discountApplyStatus === "UNAVAILABLE" && (
                  <button className="discount-apply-btn disabled">혜택 신청</button>
                )}
                {missionInfo.discountApplyStatus === "AVAILABLE" && (
                  <button className="discount-apply-btn" onClick={handleClickDiscountBtn}>
                    혜택 신청
                  </button>
                )}
                {missionInfo.discountApplyStatus === "COMPLETED" && (
                  <button className="discount-apply-btn disabled">혜택 신청 완료</button>
                )}
              </article>
            </section>
            <article className="mission-info-wrap">
              <div className="mission-info-title-wrap">
                <div></div>
                <p>꼭 확인해주세요</p>
                <div></div>
              </div>
              <div className="mission-info-content">
                <p>
                  혜택 신청은 1회만 가능하므로, 가능한 모든 미션을
                  <br />
                  완료한 후 혜택을 신청해주세요.
                </p>
                <p>
                  혜택을 신청 한 이후에는 추가 미션을 달성하여도
                  <br />
                  시크릿 혜택은 지급되지 않습니다.
                </p>
                <p>혜택 신청 이후에는 신청 취소 처리가 불가합니다.</p>
              </div>
            </article>
          </article>
          <article className="absolute-box-info-wrap">
            <p className="info-title">안내사항</p>
            <ul className="info-content">
              <li>
                혜택은 신랑·신부 중 한 명의 계정에서만 신청할 수 있으며, 모든 진행 사항은 해당
                계정에서만 관리됩니다.
              </li>
              <li>
                적립 혜택은 웨딩북을 통해 최초 예약 후 계약할 경우에만 적용되며, 다른 경로를 통한
                계약은 혜택 적립이 불가합니다.
              </li>
            </ul>
          </article>
          <p className="end-notice-text">
            시크릿 라운지 서비스는 2026년 4월 30일 종료 예정입니다. 해당 일자 이후에는 혜택 신청 및
            수령이 불가합니다.
          </p>
        </div>
      )}
      <SecretLoungeModal
        modalId="secretLounge"
        isShow={isShowModal}
        setIsShow={setIsShowModal}
        modalPointText={modalPointText}
        modalBoldText={modalBoldText}
        modalText={modalText}
        overlay={true}
        overlayValue={0.5}
        buttons={modalBtns}
      />
      <InputModal
        isShow={secretLoungeCodeModal}
        text={`🤫 시크릿 라운지\n초대 코드를 입력해주세요.`}
        inputPlaceholder="초대코드"
        inputValue={secretLoungeConfirmCode}
        setInputValue={setSecretLoungeConfirmCode}
        errorText={secretLoungeErrorText}
        overlay
        overlayValue={0.6}
        buttons={[
          {
            name: "취소",
            theme: "gray50",
            action: () => {
              setSecretLoungeCodeModal(false);
              setSecretLoungeErrorText(""); // 모달 닫으면 시크릿라운지 코드번호 불일치 에러 텍스트 초기화

              window.location.href = "h2mwbell://webview/close";
            },
          },
          {
            name: "확인",
            className: "btn-red500",
            action: () => {
              //시크릿 라운지 코드 확인 API 호출
              addLoungeCode(secretLoungeConfirmCode)
                .then((res) => {
                  // 사용 가능한 초대코드 입력시 모달 닫고 미션 정보 조회
                  setSecretLoungeCodeModal(false);
                  setSecretLoungeErrorText("");
                  getMissionInfo();
                })
                .catch(() => {
                  setSecretLoungeErrorText(
                    "앗! 초대코드가 맞지 않아요. 정확한 코드를 입력했는지 확인해 주세요.",
                  );
                });
            },
          },
        ]}
      />
      {isShowEndNoticeModal && (
        <div className="end-notice-modal-wrap">
          <div className="end-notice-modal-overlay" />
          <div className="end-notice-modal">
            <div className="end-notice-modal-content">
              <span className="end-notice-badge">서비스 종료 안내</span>
              <div className="end-notice-modal-sub">
                <p className="end-notice-modal-title">
                  시크릿 라운지 서비스는
                  <br />
                  <span>2026년 4월 30일</span>에
                  <br />
                  종료될 예정입니다.
                </p>
                <p className="end-notice-modal-text">
                  해당 일자 이후에는 시크릿 라운지
                  <br />
                  혜택 신청 및 수령이 불가능합니다.
                </p>
              </div>
            </div>
            <button
              className="end-notice-modal-btn"
              onClick={() => setIsShowEndNoticeModal(false)}
            >
              확인
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
